import {HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {authenticationFeature} from '@state/authentication/authentication.feature';
import {Observable, switchMap, take} from 'rxjs';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const store = inject(Store);
  return store.select(authenticationFeature.selectLoginInfo).pipe(
    take(1),
    switchMap((loginInfo) => {
      const commonRec = req.clone({
        setHeaders: {
          ['X-Client-Source']: 'perevir',
        },
      });
      if (loginInfo && 'token' in loginInfo && loginInfo.token) {
        const clonedRequest = commonRec.clone({
          setHeaders: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            Authorization: `Bearer ${loginInfo.token}`,
          },
        });
        return next(clonedRequest);
      }

      return next(commonRec);
    })
  );
}
